import { parseStatLines } from "./parse";

interface StatCardsProps {
  content: string;
}

export function StatCards({ content }: StatCardsProps) {
  const stats = parseStatLines(content);
  if (stats.length === 0) return null;

  return (
    <p className="cx-stat-line">
      {stats.map((stat, i) => (
        <span key={i} className="cx-stat-item">
          <strong className="cx-stat-value">{stat.value}</strong>
          {" "}{stat.label}
        </span>
      ))}
    </p>
  );
}
